<template>
    <IndexModelLayout
        :createRoute="$route('admin::time-entries.create')"
        :modelNamePlural="__('admin::time_entries.time_entries')"
    >

        <Table
            :headings="[
                __('admin::labels.date'),
                __('admin::labels.week_day'),
                __('admin::labels.checked_in_at'),
                __('admin::labels.checked_out_at'),
                __('admin::labels.work_time'),
                __('admin::labels.notes'),
            ]"
            @submit="submit"
        >
            <template #filters>
                <div class="grid grid-cols-3 gap-2">
                    <Select
                        v-model="filter.user_id"
                        :options="userOptions"
                        :placeholder="__('admin::labels.select_user')"
                        allowEmpty
                    />

                    <Datepicker
                        v-model="filter.from"
                    />

                    <Datepicker
                        v-model="filter.to"
                    />
                </div>
            </template>

            <template #results>
                <tr v-for="date in dates" :key="date">
                    <td class="!w-0 whitespace-nowrap">{{ $date(date, 'll') }}</td>
                    <td class="!w-0 whitespace-nowrap capitalize">{{ $date(date, 'dddd') }}</td>
                    <td>
                        <span
                            v-text="$date(timeEntryForDate(date).checked_in_at, 'LTS')"
                            v-if="timeEntryForDate(date)?.checked_in_at"
                        />

                        <span
                            v-text="__('admin::labels.no_check_in')"
                            class="font-medium text-red-500"
                            v-else
                        />
                    </td>
                    <td>
                        <span
                            v-text="$date(timeEntryForDate(date).checked_out_at, 'LTS')"
                            v-if="timeEntryForDate(date)?.checked_out_at"
                        />

                        <span
                            v-text="__('admin::labels.no_check_out')"
                            class="font-medium text-red-500"
                            v-else
                        />
                    </td>
                    <td>{{ timeEntryForDate(date)?.work_time || '—'  }}</td>
                    <td class="!text-left">{{ timeEntryForDate(date)?.notes || '—' }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::time-entries.edit', { time_entry: timeEntryForDate(date).id })"
                            v-if="timeEntryForDate(date)"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::time-entries.destroy', { time_entry: timeEntryForDate(date).id })"
                            v-if="timeEntryForDate(date)"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::time_entries.time_entry') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
export default {
    props: {
        request: Object,
        dates: Array,
        timeEntries: Array,
        userOptions: Object,
    },
    data() {
        return {
            filter: this.$inertia.form({
                user_id: this.request.user_id || '',
                from: this.request.from,
                to: this.request.to,
            }),
            deleting: null,
        };
    },
    methods: {
        submit() {
            this.filter.get(this.$route('admin::time-entries.index'));
        },
        timeEntryForDate(date) {
            return this.timeEntries.find(timeEntry => timeEntry.date === date);
        },
    }
}
</script>
